import { Action, ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import {
  CandidatesPageFilter,
  candidatesPageFilterReducer,
} from '@modules/candidates/+filter/store';
import { Pagination, paginationReducer } from '@shared/pagination';

import { candidatesConfig } from '../candidates.config';
import { CandidatesBestJobs, candidatesBestJobsReducer } from './best-jobs/best-jobs.reducer';
import * as candidatesActions from './candidates.actions';

export interface CandidatesPageState {
  candidates: Pagination;
  similar: Pagination;
  jobs: CandidatesBestJobs;
  filter: CandidatesPageFilter;
}

export const candidatesPageReducers: ActionReducerMap<CandidatesPageState, Action> = {
  candidates: paginationReducer(
    candidatesActions.candidatesPageList.type,
    candidatesActions.candidatesPageClear.type,
  ),
  similar: paginationReducer(
    candidatesActions.candidatesSimilarList.type,
    candidatesActions.candidatesSimilarClear.type,
  ),
  jobs: candidatesBestJobsReducer,
  filter: candidatesPageFilterReducer,
};

export const getCandidatesPageState = createFeatureSelector<CandidatesPageState>('candidatesPage');

export const getCandidatesPageFilter = createSelector(
  getCandidatesPageState,
  (state: CandidatesPageState) => !!state && state.filter,
);

export const getCandidatesPageFilterTotalLabels = createSelector(
  getCandidatesPageFilter,
  (filter: CandidatesPageFilter) => {
    const statusesCount = filter?.statuses?.length || 0;
    const favorites = filter?.favorites ? 1 : 0;
    const silver = filter?.silver ? 1 : 0;
    const alumni = filter?.alumni ? 1 : 0;
    const referral = filter?.referral ? 1 : 0;
    return statusesCount + favorites + silver + alumni + referral;
  },
);

export const getCandidatesPageFilterTotal = createSelector(
  getCandidatesPageFilter,
  getCandidatesPageFilterTotalLabels,
  (filter: CandidatesPageFilter, totalFiltersLabel) => {
    const namesCount = filter?.candidateNames?.length || 0;
    const jobTitlesCount = filter?.jobTitles?.length || 0;
    const companiesTitlesCount = filter?.companies?.length || 0;
    const minimumDegreeTitlesCount = filter?.minimumDegree ? 1 : 0;
    const fieldOfStudyDegreeTitlesCount = filter?.fieldOfStudy?.length ? 1 : 0;
    const skills = filter?.skills?.length || 0;
    const schools = filter?.schools?.length || 0;
    const keywordsCount = filter?.keywords?.length || 0;
    const locationsCount = filter?.locations?.length || 0;
    const experienceCount =
      filter?.experiences?.max !== candidatesConfig.filter.experience.max ||
      filter?.experiences?.min !== candidatesConfig.filter.experience.min
        ? 1
        : 0;
    const resumeUploadDate = filter?.resumeUploadDate != null ? 1 : 0;

    return (
      namesCount +
      jobTitlesCount +
      keywordsCount +
      locationsCount +
      experienceCount +
      skills +
      schools +
      companiesTitlesCount +
      minimumDegreeTitlesCount +
      fieldOfStudyDegreeTitlesCount +
      totalFiltersLabel +
      resumeUploadDate
    );
  },
);
